__turbopack_context__.v({
  "enter": "modalCloseButton-module-scss-module__bM0sIq__enter",
  "exit": "modalCloseButton-module-scss-module__bM0sIq__exit",
  "fade-in": "modalCloseButton-module-scss-module__bM0sIq__fade-in",
  "fade-out": "modalCloseButton-module-scss-module__bM0sIq__fade-out",
  "fade-out-80": "modalCloseButton-module-scss-module__bM0sIq__fade-out-80",
  "iconButton": "modalCloseButton-module-scss-module__bM0sIq__iconButton",
  "slide-in-from-bottom": "modalCloseButton-module-scss-module__bM0sIq__slide-in-from-bottom",
  "slide-in-from-left": "modalCloseButton-module-scss-module__bM0sIq__slide-in-from-left",
  "slide-in-from-right": "modalCloseButton-module-scss-module__bM0sIq__slide-in-from-right",
  "slide-in-from-top": "modalCloseButton-module-scss-module__bM0sIq__slide-in-from-top",
  "slide-out-to-bottom": "modalCloseButton-module-scss-module__bM0sIq__slide-out-to-bottom",
  "slide-out-to-left": "modalCloseButton-module-scss-module__bM0sIq__slide-out-to-left",
  "slide-out-to-right": "modalCloseButton-module-scss-module__bM0sIq__slide-out-to-right",
  "slide-out-to-top": "modalCloseButton-module-scss-module__bM0sIq__slide-out-to-top",
  "zoom-in": "modalCloseButton-module-scss-module__bM0sIq__zoom-in",
  "zoom-out": "modalCloseButton-module-scss-module__bM0sIq__zoom-out",
});
